import React from 'react';
import cx from 'classnames';
import styles from './ButtonUnstyled.css?module';

class ButtonUnstyled extends React.Component {
  render() {
    const {children, className, ...rest} = this.props;

    return (
      <button className={cx(styles.container, className)} {...rest}>
        {children}
      </button>
    );
  }
}

export default ButtonUnstyled;
